// Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import React from 'react';
import { Pie } from 'react-chartjs-2';
import { Chart, ArcElement, Tooltip, Legend } from 'chart.js';
import { CONSUMED_QUERY_HOURS, HOURS, REAMAINING_QUERY_HOURS } from '../constants/constants';

Chart.register(ArcElement, Tooltip, Legend);

type PieChartProps = {
    remainingQueryHours: string;
    totalQueryHours: string;
};

const PieChart: React.FC<PieChartProps> = ({ remainingQueryHours, totalQueryHours }) => {
    const parseTime = (timeString: string) => {
        const timePattern = /(\d+)h\s*(\d*)m/;
        const match = timeString.match(timePattern);
        if (match) {
            const hours = parseInt(match[1], 10);
            const minutes = parseInt(match[2] || '0', 10);
            return hours + minutes / 60;
        }
        return 0;
    };

    const remainingQueryHoursParsed = parseTime(remainingQueryHours);
    const totalQueryHoursParsed = parseTime(totalQueryHours);

    const consumedQueryHoursPercentage = parseFloat(
        ((totalQueryHoursParsed - remainingQueryHoursParsed) * 100 / totalQueryHoursParsed).toFixed(2)
    );
    const remainingQueryHoursPercentage = parseFloat(
        ((remainingQueryHoursParsed * 100) / totalQueryHoursParsed).toFixed(2)
    );

    const data = {
        labels: [
            `${CONSUMED_QUERY_HOURS} (${consumedQueryHoursPercentage}%)`,
            `${REAMAINING_QUERY_HOURS} (${remainingQueryHoursPercentage}%)`
        ],
        datasets: [
            {
                label: HOURS,
                data: [totalQueryHoursParsed-remainingQueryHoursParsed, remainingQueryHoursParsed],
                backgroundColor: ['#FF6384', '#36A2EB'],
                hoverBackgroundColor: ['#ffa9bc', '#87bffa'],
            },
        ],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
    };

    return (
        <div style={{ width: '300px', height: '300px', margin: 'auto', paddingTop: '15px' }}>
            <Pie data={data} options={options} />
        </div>
    );
};

export default PieChart;
